import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { authService } from 'auth/services';

import { useIsAuthenticated } from '@azure/msal-react';

import { PlusIcon, PlusIconDefault } from 'features/order-tracker/shared-components/svg';
import { selectSiteContact, showAddNewContactForm } from 'features/order-tracker/store/actions';
import { getAmendAppointmentInfo } from 'features/order-tracker/store/selectors';

import { SectionHeader } from '../../../components';
import { NewSiteContactForm } from '../NewSiteContactForm';
import { ContactItem } from './components';
import { ANALYTICS_APPT_ADD_SITE_CONTACT, CONTACT_DETAILS_GROUP_LEGEND_TEXT, SUB_TITLE, TITLE } from './constants';

import styles from './styles.module.scss';

export const ContactDetails: React.FC = () => {
  const { addingNewContact, contacts, selectedContact } = useSelector(getAmendAppointmentInfo);
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const executeScroll = (): void => {
    setTimeout(() => buttonRef.current?.scrollIntoView({ block: 'start', behavior: 'smooth' }), 0);
  };
  const OpenContactFormButtonIcon = addingNewContact ? PlusIcon : PlusIconDefault;

  return (
    <>
      <SectionHeader title={TITLE} subtitle={SUB_TITLE} className={styles.contactDetailsHeader} />
      <fieldset className={styles.contactDetailsContent}>
        <legend>{CONTACT_DETAILS_GROUP_LEGEND_TEXT}</legend>
        {contacts.map((contact) => (
          <ContactItem
            isSelected={contact.contactKey === selectedContact}
            key={contact.contactKey}
            {...contact}
            handleChange={() => {
              isAuthenticated && authService.throttledRefreshToken();
              dispatch(selectSiteContact(contact.contactKey));
            }}
          />
        ))}
      </fieldset>
      <button
        ref={buttonRef}
        className={styles.newContactButton}
        type="button"
        data-analytics-link={ANALYTICS_APPT_ADD_SITE_CONTACT}
        onClick={() => {
          executeScroll();
          dispatch(showAddNewContactForm(!addingNewContact));
        }}
      >
        <OpenContactFormButtonIcon className={styles.newContactIcon} />
        Add new site contact
      </button>
      {addingNewContact && <NewSiteContactForm />}
    </>
  );
};
